import { enUS as materialEnglish, srRS as materialSerbian, Localization } from '@mui/material/locale';
import { LanguageCodeEnum } from '../common/enums/common.enum';
import { UiLanguage } from './language.config';

/**
 * The third-party halves of a language: MUI's built-in texts (table pagination, "No
 * options") and the dayjs locale behind month and weekday names.
 *
 * MUI's `srRS` is Latin script ("Redova po stranici"), which is what is wanted. The date
 * pickers ship no Serbian at all, so their texts come from our own translation files - see
 * `usePickerLocaleText`.
 */
export const MATERIAL_LOCALES: Record<UiLanguage, Localization> = {
  [LanguageCodeEnum.SRB]: materialSerbian,
  [LanguageCodeEnum.ENG]: materialEnglish
};

/** `sr` is Latin; `sr-cyrl` would be the Cyrillic one, which is not offered yet. */
export const DAYJS_LOCALES: Record<UiLanguage, string> = {
  [LanguageCodeEnum.SRB]: 'sr',
  [LanguageCodeEnum.ENG]: 'en'
};
